export default "__VITE_ASSET__HxLY6i$F__"